import { OptionCategory } from 'owa-options-core';
import premiumDashboardFeaturesSubCategory from '../config/PremiumDashboardFeaturesSubCategory';
import premiumDashboardSecuritySubCategory from '../config/premiumDashboardSecuritySubCategory';
import premiumDashboardDomainSubCategory from '../config/premiumDashboardDomainSubCategory';
import { ControlIcons } from 'owa-control-icons';

let premiumCategory: OptionCategory = {
    key: 'premium',
    titleStringKey: 'optionTitle_premium',
    icon: ControlIcons.Diamond,
    subcategories: [
        premiumDashboardFeaturesSubCategory,
        premiumDashboardSecuritySubCategory,
        premiumDashboardDomainSubCategory,
    ],
};

export default premiumCategory;
